import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { useEffect, useRef, useState } from "react";
import BuyInvoiceFormConfig from "./form";
import styles from "./style.module.scss";
import { BuyInvoiceFormData, buyInvoiceRelatedAttributes } from "@/formTypes/BuyInvoiceDataType";
import GenericForm, { ConfirmationConfig } from "../GenericForm";
import { BuyInvoiceApi, BuyInvoiceDataType } from "@/api/BuyInvoiceApi";
import QuickAddProductForm from "../QuickAddProductForm";
import { Col, Row } from "reactstrap";
import PriceSelector from "@components/dynamic/PriceSelector";
import { PriceApi } from "@/api/PricesApi";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectDocumentSummary, selectEDocumentSummary } from "@/store/slices/utils/eDocumentSelectors";
import { INVOICE_CONTADO_TYPE_CODE, INVOICE_HOLDING_TYPE_CODE, ON_INVOICE_DISCOUNT_TYPE_CODE, CASH_PAYMENT_WAY_CODE, BuyInvoiceType } from "@utils/Constants";
import { addPaymentWay, clearDocument, clearDocumentReferences, loadProducts, setDocumentComments, setPrice, setPriceCode } from "@/store/slices/eDocumentSlides";
import { StoredReference, serializeStoredReferences } from "@utils/DocumentReferences";
import { CurrencyApi } from "@/api/CurrencyApi";
import { setCurrency } from "@/store/slices/currencySlides";
import { ActivityCodeApi } from "@/api/ActivityCodeApi";
import LoadingScreen from "@components/content/LoadingScreen";
import EdocumentProductList from "@components/dynamic/EdocumentProductList";
import { ProviderApi } from "@/api/ProviderApi";
import { showAlert } from "@utils/Alert";
import { omitProperties, removeFunctionFromObject, stripHtmlTags } from "@utils/Utils";
import { ConfirmPrintPubSub, CurrencyIdPubSub, ScrollToDiscountCodeSelectPubSub } from "@utils/pubsubs/PubSub";
import { flushDocumentProductEdits } from "@utils/eDocumentFlush";
import EdocumentComments from "@components/dynamic/EdocumentComments";
import DocumentPaymentWaysForm from "../DocumentPaymentWaysForm";
import { HiddenableContainer } from "@components/layout/HiddenableContainer";
import { EDocumentPaymentWayDataType } from "@/formTypes/EDocumentPaymentWayDataType";
import EdocumentPaymentWayList from "@components/dynamic/EdocumentPaymentWayList";
import { generateCustomInformationJson, sendEBuyInvoiceData } from "@utils/EDocument";
import { BuyInvoiceProductDataType } from "@/api/BuyInvoiceProductApi";
import { BuyInvoicePaymentDataType } from "@/api/BuyInvoicePaymentApi";
import { generateAndUploadPdf } from "@utils/htmlExport";
import DocumentPrintConfirmation from "@components/content/DocumentPrintConfirmation";
import { EasyposEInvoice } from "@/atv/submitInvoice";
import { ProviderDataType } from "@/api/ProviderApi";
import { BuyInvoiceFormDataKeys } from "@/generated/BuyInvoiceFormDataKeys";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";
import { loadReferenceFormLabel } from "@utils/Forms";
import { resolveDocumentClientNames } from "@utils/documentClientSnapshot";

type BuyInvoiceFormProps = {
  id?: string;
  copyData?: boolean
  formId: string,
  buyInvoiceType?: BuyInvoiceType,
  saveRedirectUrl: string
}

const BuyInvoiceForm = (props: BuyInvoiceFormProps) => {
  const dispatch = useAppDispatch()
  const { copyData = false, id: preLoadedBuyInvoiceId, buyInvoiceType = "Buy" } = props
  const formRef = useRef<DynamicFormRef>(null);
  const customFieldForm = useRef<DynamicFormRef>(null);

  const [defaultData, setDefaultData] = useState<BuyInvoiceDataType>({});
  const [providers, setProviders] = useState<ProviderDataType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const suscriptionData = useAppSelector((state) => state.suscription.suscription);
  const documentReferences = useAppSelector((state) => state.eDocument.documentReferences);
  const documentCurrency = useAppSelector((state) => state.currency);
  const documentSummary = useAppSelector(selectDocumentSummary);
  const [easyposEBuyInvoice, setEasyposEBuyInvoice] = useState<EasyposEInvoice>()
  const [documentType, setDocumentType] = useState<string>("0");
  const [formConfig, setFormConfig] = useState<any>();

  useEffect(() => {
    setIsLoading(true)
    loadFormConfig()
    loadDefaultData()
    if (suscriptionData) {
      setEasyposEBuyInvoice(new EasyposEInvoice(suscriptionData))
    }
  }, [suscriptionData])

  const loadFormConfig = () => {
    const formConfig = loadReferenceFormLabel(BuyInvoiceFormConfig, suscriptionData);
    if (suscriptionData?.id) {
      setFormConfig(formConfig)
    }
  }


  const onInputUpdate = (name: keyof BuyInvoiceFormData, value: any, event?: React.ChangeEvent<any>) => {
    if (name === "providerId") {
      const client = providers.find(c => c.id === value);
      if (client?.id) {
        populateProviderData(client);
      }
    }
    if (name === "tipo") {
      setDocumentType(value)
    }
  }

  const createProviderDataObject = (provider: ProviderDataType): BuyInvoiceDataType => {
    const providerDefaultDocumentType = `${(provider.tipo || 0)}`; ``
    const providerData: BuyInvoiceDataType = {
      providerId: provider.id,
      ...resolveDocumentClientNames(provider),
      plazo: provider.plazo || 0,
      tel1: provider.telefono1,
      tel1_cd: provider.telefono1_cd,
      tel2: provider.telefono2,
      tel2_cd: provider.telefono2_cd,
      email: provider.email,
      tipo_identificacion: provider.tipo_identificacion,
      identificacion: provider.identificacion,
      direccion: stripHtmlTags(provider.direccion || ""),
      tipo: providerDefaultDocumentType
    }

    return providerData
  }

  const populateProviderData = async (provider: ProviderDataType) => {
    if (provider?.id) {

      const providerDefaultDocumentType = `${(provider.tipo || 0)}`;
      const providerData = createProviderDataObject(provider)

      setDocumentType(providerDefaultDocumentType)
      formRef.current?.setFormValue("multiple",
        {
          ...providerData,
          provider_code: provider.codigo
        }
        , "multipleData");
    }
  }

  const onInputKeyDown = (name: keyof BuyInvoiceFormData | "provider_code", event?: React.KeyboardEvent<any>) => {
    if (name === "provider_code") {
      if (event?.key == "Enter") {
        event?.preventDefault();
        event?.stopPropagation();
        const input = event.target as HTMLInputElement
        selectProviderByCode(input.value)
      }
    }
  }

  const selectProviderByCode = async (code: string) => {
    const client = providers.find(c => c.codigo === code);
    if (client?.id) {
      formRef.current?.setFormValue("providerId", client.id, "String");
    } else {
      showAlert("danger", "No existe ningun Provedor con ese codigo");
    }
  }

  const addPaymentWayToDocument = (data: EDocumentPaymentWayDataType) => {
    dispatch(addPaymentWay(data))
  }

  const preLoadInvoiceData = async (providers: ProviderDataType[]) => {
    if (preLoadedBuyInvoiceId) {
      let invoice = await BuyInvoiceApi.get(preLoadedBuyInvoiceId, {
        selectionSet: [
          ...BuyInvoiceFormDataKeys.filter(k => !buyInvoiceRelatedAttributes.includes(k)),
          "currency.*",
          "buyInvoiceProducts.*",
        ]
      })
      const formData = omitProperties(invoice, ["sequence", "numero", "salemanId", "recibeId", "invoice_key", "id", "createdAt", "updatedAt", "edocument_status_payload", "einvoice_status", "anulada"], true);
      setDocumentType(`${invoice.tipo}`)
      const provider = providers.find(c => c.id == formData.providerId);
      invoice = {
        ...invoice,
        provider
      }

      const providerData = createProviderDataObject(provider as ProviderDataType)
      const fecha = `${invoice.fecha}`.substring(0, 10);

      formRef.current?.resetFormValue({
        ...providerData,
        ...formData,
        fecha,
        provider_code: provider?.codigo
      })
      dispatch(setDocumentComments(`${formData.document_comments || ""}`))

      if (formData.customfields) {
        try {
          const customFields = JSON.parse(formData.customfields);
          const fieldData = customFields.reduce((a: Record<string, string>, v: { title: string, value: string, }) => {
            return {
              ...a,
              [v.title]: v.value
            }
          }, {})
          customFieldForm.current?.resetFormValue(fieldData)
        } catch (err) {
          console.log("error parsing json")
        }
      }

      if (invoice.buyInvoiceProducts) {
        const invoiceProducts = invoice.buyInvoiceProducts.map(ip => {
          return omitProperties(ip, ["id", "invoiceId", "createdAt", "updatedAt"], true);
        })
        dispatch(loadProducts(invoiceProducts as EDocumentProductDataType[]))
      }
      if (invoice.currency && invoice.currencyId) {
        CurrencyIdPubSub.publish({ currencyId: invoice.currencyId })
      }
    }
  }

  const loadDefaultData = async (resetLoad = false) => {
    try {
      const { items } = await ProviderApi.fetchAll();
      setProviders(items);
      if (copyData && !resetLoad) {
        await preLoadInvoiceData(items)
      } else {
        dispatch(clearDocument())
        let defaultData: BuyInvoiceDataType = {}
        const defaultPrice = await PriceApi.getDefaultPrice()

        if (typeof defaultPrice === 'number') {
          dispatch(setPriceCode(defaultPrice))
        } else {
          let priceData = removeFunctionFromObject(defaultPrice)
          dispatch(setPrice(priceData))
        }
        const defaultCurrency = await CurrencyApi.getDefaultCurrency()
        if (defaultCurrency.id) {
          dispatch(setCurrency(removeFunctionFromObject(defaultCurrency)))
          defaultData["currencyId"] = defaultCurrency.id
          if (defaultCurrency.exchange_rate) {
            defaultData["exchange_rate"] = defaultCurrency.exchange_rate
          }
          CurrencyIdPubSub.publish({ currencyId: defaultCurrency.id })
        }
        const defaultActivityCodeCurrency = await ActivityCodeApi.getDefaultActivityCode()
        if (defaultActivityCodeCurrency.code) {
          defaultData["activitycode"] = `${defaultActivityCodeCurrency.code}`
        }

        formRef.current?.setFormValue("multiple", defaultData, "multipleData")
        setDefaultData(defaultData)
        if (resetLoad) {
          formRef.current?.resetFormValue(defaultData)
          customFieldForm.current?.resetFormValue()
        }
      }
    } finally {
      setIsLoading(false)
    }
  }

  const createBuyInvoice = async (formData: BuyInvoiceDataType): Promise<BuyInvoiceDataType> => {
    const eDocumentState = flushDocumentProductEdits();
    const documentSummaryState = selectEDocumentSummary(eDocumentState);
    let buyInvoiceData: BuyInvoiceDataType = {}
    const { documentProducts = [], documentDiscountType, documentPaymentWays, isDocumentExempted, documentDiscountCode } = eDocumentState

    let products = [...documentProducts];
    if (products?.length == 0) {
      throw Error("Por favor agregue algun producto a la factura de compra")
    }

    if (documentSummaryState.descuento > 0 && !documentDiscountCode) {
      ScrollToDiscountCodeSelectPubSub.publish({})
      throw Error("Por favor seleccione un codigo de descuento antes de continuar")
    } else {
      buyInvoiceData["discountCode"] = documentDiscountCode
    }

    if (!suscriptionData) {
      throw Error("No fue posible obtener la informacion de su suscripcion")
    }

    const totalPaymentWays = documentPaymentWays?.reduce((a, p) => a + Number(p.monto || 0), Number(0)) || 0;
    if (formData.tipo == INVOICE_CONTADO_TYPE_CODE || formData.tipo == INVOICE_HOLDING_TYPE_CODE) {
      if (totalPaymentWays < documentSummaryState.total) {
        throw Error("Las formas de pago no cubren el monto del documento")
      }
    }

    const customField = await customFieldForm.current?.getFormData()

    if (eDocumentState.hasAdditionalData) {
      if (!customField) {
        throw Error("Por favor ingrese la informacion addicional que es obligatoria")
      } else {
        buyInvoiceData["customfields"] = generateCustomInformationJson(customField)
      }
    }

    let pagada = false;
    let status = "pendiente";
    if (formData.tipo == INVOICE_CONTADO_TYPE_CODE) {
      if (!suscriptionData?.no_auto_cancel_contado) {
        pagada = true;
        status = "pagada"
      }
    }

    const fecha = `${formData.fecha}`.substring(0, 10);

    buyInvoiceData = {
      ...formData,
      ...buyInvoiceData,
      fecha: `${fecha} 12:00:00`,
      subtotal: documentSummaryState.subtotal,
      descuento: documentDiscountType == ON_INVOICE_DISCOUNT_TYPE_CODE ? documentSummaryState.descuento : 0,
      impuestos: documentSummaryState.impuestos,
      total: documentSummaryState.total,
      currencyId: documentCurrency.currencyApiId,
      exenta: isDocumentExempted,
      buyInvoiceType,
      pagada,
      status,
      porcenta_descuento: eDocumentState.documentDiscount,
      document_comments: eDocumentState.documentComments
    }

    if (products) {
      const buyInvoicePayments = generateBuyInvoicePayments(documentPaymentWays, buyInvoiceData);
      if (documentReferences && documentReferences.length > 0) {
        buyInvoiceData.info_references = serializeStoredReferences(documentReferences as StoredReference[])
      }
      const createdBuyInvoice = await BuyInvoiceApi.createBuyInvoiceAndProducts(buyInvoiceData, products as BuyInvoiceProductDataType[], buyInvoicePayments)

      if (easyposEBuyInvoice && suscriptionData?.einvoice_status) {
        await sendEBuyInvoiceData(easyposEBuyInvoice, `${createdBuyInvoice.id}`)
      }

      clearForm()
      showAlert("success", "La Factura Electronica de compra ha sido creada existosamente")

      ConfirmPrintPubSub.publish({
        openOffCanvas: true,
        printVersionUrl: `/user/buyInvoices/print/${createdBuyInvoice.id}/0/1`
      })

      generateAndUploadPdf(`/user/buyInvoices/print/${createdBuyInvoice.id}/0/1`, `${suscriptionData?.numero}/pdfs/BuyInvoice/${createdBuyInvoice.invoice_key}.pdf`)
      return createdBuyInvoice;
    }

    return {} as BuyInvoiceDataType;
  }

  const generateBuyInvoicePayments = (payment: EDocumentPaymentWayDataType[] = [], buyInvoiceData: BuyInvoiceDataType): BuyInvoicePaymentDataType[] => {
    const paymentTotal = payment.reduce((a, v) => a + Number(v.monto || 0), Number(0))
    let moneyBack = paymentTotal - Number(documentSummary?.total || 0)

    return payment.map(p => {
      let vuelto = Number(0)
      if (p.forma_pago == `${CASH_PAYMENT_WAY_CODE}`) {
        vuelto = moneyBack
        moneyBack = 0
      }
      const buyInvoicePayment: BuyInvoicePaymentDataType = {
        descripcion: `Pago Factura #${buyInvoiceData.numero}`,
        monto: Number(p.monto),
        vuelto: vuelto,
        formaPago: `${p.forma_pago}`,
        digitosTarjeta: p.digitosTarjeta,
        numAprobacion: p.numAprobacion,
        exchange_rate: buyInvoiceData.exchange_rate,
        created: buyInvoiceData.fecha,
        currencyId: buyInvoiceData.currencyId,
        bankAccountId: p.bankAccountId,
        creditOperatorId: p.creditOperatorId
      }
      return buyInvoicePayment
    })

  }

  const clearForm = async () => {
    dispatch(clearDocument())
    dispatch(clearDocumentReferences())
    loadDefaultData(true)
  }

  const getCreateConfirmation = (): ConfirmationConfig | undefined => {
    const { ask_confirm = false } = suscriptionData || {}
    if (ask_confirm) {
      return {
        message: "Esta seguro que desea crear la Factura Electronica de Compra"
      }
    }
  }

  return (
    <>
      {formConfig?.sections && (<GenericForm<BuyInvoiceFormData, BuyInvoiceDataType>
        ref={formRef}
        formId={props.formId}
        defaultData={defaultData}
        confirmationConfig={getCreateConfirmation()}
        modelRelativeObjects={buyInvoiceRelatedAttributes}
        onInputChange={onInputUpdate}
        onInputKeyDown={onInputKeyDown}
        formConfig={formConfig}
        getById={(...arg) => BuyInvoiceApi.get(...arg)}
        createFn={(...arg) => createBuyInvoice(...arg)}
      >
        <Row>
          <Col>
            <h3>
              Productos
            </h3>
          </Col>
          <Col xs="1">
            <PriceSelector />
          </Col>
        </Row>
        <QuickAddProductForm />
        <EdocumentProductList />
        <EdocumentComments />
      </GenericForm >
      )}

      <HiddenableContainer show={INVOICE_CONTADO_TYPE_CODE == documentType || INVOICE_HOLDING_TYPE_CODE == documentType}>
        <Row>
          <Col md={{
            size: 10,
            offset: 1
          }}>
            <hr />
            <h3 className="mb-4">
              Agregar Forma de Pago
            </h3>
            <DocumentPaymentWaysForm innerForm={true} onPaymentWayAdded={addPaymentWayToDocument} />
            <hr className="mt-4 mb-4" />
            <EdocumentPaymentWayList documentSummary={documentSummary} />
          </Col>
        </Row>
      </HiddenableContainer>
      <LoadingScreen isLoading={isLoading} />
      <DocumentPrintConfirmation
        title="Imprimir Factura"
      />
    </>

  )
}

export default BuyInvoiceForm;